(function () {
  var SHAPES = 4;
  var seq = 0;

  function el(tag, cls) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    return n;
  }

  function setOpen(item, open) {
    var btn = item.querySelector('.pgfq__b');
    var panel = item.querySelector('.pgfq__a');
    item.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) panel.removeAttribute('hidden');
    else panel.setAttribute('hidden', '');
  }

  // Only one item open per list.
  function bind(group) {
    if (group.dataset.pgfqBound) return;
    group.dataset.pgfqBound = '1';
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.pgfq__b');
      if (!btn || !group.contains(btn)) return;
      var item = btn.closest('.pgfq__i');
      var willOpen = !item.classList.contains('is-open');
      group.querySelectorAll('.pgfq__i.is-open').forEach(function (o) {
        if (o !== item) setOpen(o, false);
      });
      setOpen(item, willOpen);
    });
  }

  function build(qHtml, nodes, i) {
    seq += 1;
    var id = 'pgfq-r' + seq;
    var item = el('div', 'pgfq__i');
    var h3 = el('h3', 'pgfq__q');
    var btn = el('button', 'pgfq__b');
    btn.type = 'button';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', id);
    var shw = el('span', 'pgfq__shw');
    shw.setAttribute('aria-hidden', 'true');
    shw.appendChild(el('span', 'pgfq__sh pgfq__sh--' + ((i % SHAPES) + 1)));
    var t = el('span', 'pgfq__t');
    t.innerHTML = qHtml;
    var tg = el('span', 'pgfq__tg');
    tg.setAttribute('aria-hidden', 'true');
    btn.appendChild(shw);
    btn.appendChild(t);
    btn.appendChild(tg);
    h3.appendChild(btn);
    var panel = el('div', 'pgfq__a');
    panel.id = id;
    panel.setAttribute('role', 'region');
    panel.setAttribute('hidden', '');
    nodes.forEach(function (n) { panel.appendChild(n); });
    item.appendChild(h3);
    item.appendChild(panel);
    return item;
  }

  // Rich text bodies (pages, blog posts) keep FAQs as an h2 followed by h3 and p
  // pairs. Wrap those pairs in accordion rows so they match the rest of the site.
  function enhanceRich(root) {
    root.querySelectorAll('h2').forEach(function (h2) {
      if (!/question|faq/i.test(h2.textContent)) return;
      var items = [];
      var n = h2.nextElementSibling;
      var cur = null;
      while (n && n.tagName !== 'H2') {
        var next = n.nextElementSibling;
        if (n.tagName === 'H3') {
          cur = { q: n, a: [] };
          items.push(cur);
        } else if (cur && !/^(SCRIPT|STYLE)$/.test(n.tagName)) {
          cur.a.push(n);
        }
        n = next;
      }
      if (items.length < 2) return;
      var group = el('div', 'pgfq');
      group.setAttribute('data-pg-faq', '');
      items.forEach(function (it, i) {
        group.appendChild(build(it.q.innerHTML, it.a, i));
        it.q.remove();
      });
      h2.insertAdjacentElement('afterend', group);
      bind(group);
    });
  }

  function init() {
    document.querySelectorAll('[data-pg-faq]').forEach(bind);
    document.querySelectorAll('[data-pg-faq-rich]').forEach(function (r) {
      if (r.dataset.pgfqDone) return;
      r.dataset.pgfqDone = '1';
      enhanceRich(r);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
